import { ConfirmInfo } from '@coop/components';

import type { A11yTextType } from '../../../../common/components/A11yTextWrapper/A11yTextWrapper';
import useModal from '../../../../common/hooks/useModal';
import { ProductInfoProperty } from '../../ProductInfoProperty';
import styles from './ProductDetailsHistoricalPrice.module.scss';

const ProductDetailsHistoricalPrice = (props: {
    productIdentifier: string;
    visualText: string;
    a11yText: string;
    a11yType: A11yTextType;
}) => {
    const { isOpen, open, close } = useModal(
        'HistoricalPriceConfirmation',
        undefined,
        props.productIdentifier,
    );

    return (
        <ConfirmInfo
            renderTrigger={(ref) => (
                <button
                    type="button"
                    className={styles.Button}
                    aria-label={props.a11yText}
                    ref={ref}
                    onClick={open}
                >
                    <ProductInfoProperty.Black
                        underlined
                        a11yText={props.a11yText}
                        a11yType={props.a11yType}
                    >
                        {props.visualText}
                    </ProductInfoProperty.Black>
                </button>
            )}
            show={isOpen}
            message="Priset avser vårt lägsta pris på denna vara under de senaste 30 dagarna före prissänkningen."
            heading="Tidigare lägsta pris"
            close={close}
        />
    );
};

export default ProductDetailsHistoricalPrice;
